<template>
  <div class="card mb-25 border-0 rounded-0 bg-white add-user-card">
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
      <Form @submit="addSociete" :validation-schema="societeSchema" :initial-values="initialValues">
        <div class="row">
          <div class="col-md-4 mt-20">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="custom-checkbox">
                <Field name="estRegimeTPS" type="checkbox" :value="true" :unchecked-value="false" v-slot="{ field }">
                  <input type="checkbox" v-bind="field" />
                </Field>
                <span class="checkmark"></span>
                Est Régime TPS ?
              </label>
            </div>
          </div>

          <div class="col-md-4 mt-20">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="custom-checkbox">
                <Field name="estModeMecef" type="checkbox" :value="true" :unchecked-value="false" v-slot="{ field }">
                  <input type="checkbox" v-bind="field" />
                </Field>
                <span class="checkmark"></span>
                Est Mode MECEF ?
              </label>
            </div>
          </div>

          <div class="col-md-4 mt-20">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Sigle <span class="text-danger">*</span>
              </label>
              <Field name="sigle" type="text" class="form-control shadow-none fs-md-15 text-black"
                placeholder="Entrer le sigle" />
              <ErrorMessage name="sigle" class="text-danger" />
            </div>
          </div>

          <div class="col-md-4 mb-3">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Dénomination<span class="text-danger">*</span>
              </label>
              <Field name="denomination" type="text" class="form-control shadow-none fs-md-15 text-black"
                placeholder="Entrer la dénomination" />
              <ErrorMessage name="denomination" class="text-danger" />
            </div>
          </div>

          <div class="col-md-4 mb-3">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Raison sociale <span class="text-danger">*</span>
              </label>
              <Field name="raisonSocial" type="text" class="form-control shadow-none fs-md-15 text-black"
                placeholder="Entrer la raison sociale" />
              <ErrorMessage name="raisonSocial" class="text-danger" />
            </div>
          </div>

          <div class="col-md-4 mb-3">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                N° RCCM <span class="text-danger">*</span>
              </label>
              <Field name="rccm" type="text" class="form-control shadow-none fs-md-15 text-black"
                placeholder="Entrer le régistre de commerce" />
              <ErrorMessage name="rccm" class="text-danger" />
            </div>
          </div>

          <div class="col-md-4 mb-3">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                N° IFU <span class="text-danger">*</span>
              </label>
              <Field name="ifu" type="text" class="form-control shadow-none fs-md-15 text-black"
                placeholder="Entrer l'ifu" />
              <ErrorMessage name="ifu" class="text-danger" />
            </div>
          </div>

          <div class="col-md-4 mb-3">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Téléphone <span class="text-danger">*</span>
              </label>
              <Field name="telephone" v-model="telephone" v-slot="{ field }">
                <vue-tel-input placeholder="Entrer le numéro de téléphone" v-model="field.value" v-bind="field"
                  defaultCountry="BJ" mode="international" @validate="validate"
                  class="shadow-none fs-md-15 text-black py-2">
                </vue-tel-input>
              </Field>
              <div v-if="!validPhone" class="text-danger">Veuillez entrer un numéro correcte</div>
              <ErrorMessage name="telephone" class="text-danger" />
            </div>
          </div>

          <div class="col-md-4 mb-3">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Adresse <span class="text-danger">*</span>
              </label>
              <Field name="adresse" type="text" class="form-control shadow-none fs-md-15 text-black"
                placeholder="Entrer l'adresse" />
              <ErrorMessage name="adresse" class="text-danger" />
            </div>
          </div>

          <div class="col-md-4 mb-3">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Message Commercial
              </label>
              <Field name="messageCommercial" type="text" class="form-control shadow-none fs-md-15 text-black"
                placeholder="Entrer votre message commercial" />
              <ErrorMessage name="messageCommercial" class="text-danger" />
            </div>
          </div>

          <div class="col-md-4 mb-3">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Lieu d'impression des factures
              </label>
              <Field name="lieuImpression" type="text" class="form-control shadow-none fs-md-15 text-black"
                placeholder="Entrer le lieu d'impression" />
              <ErrorMessage name="lieuImpression" class="text-danger" />
            </div>
          </div>

          <!-- LOGO -->
          <div class="col-md-4 mb-3">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Joindre le logo
              </label>
              <Field name="logo" type="file" accept="image/jpeg, image/png, application/pdf"
                class="form-control shadow-none fs-md-15 text-black" placeholder="Logo" />
            </div>
            <ErrorMessage name="logo" class="text-danger" />
          </div>

          <!-- ENTETE -->
          <div class="col-md-4 mb-3">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Joindre l'entête
              </label>
              <Field name="entete" type="file" accept="image/jpeg, image/png, application/pdf"
                class="form-control shadow-none fs-md-15 text-black" placeholder="Entête" />
            </div>
            <ErrorMessage name="entete" class="text-danger" />
          </div>

          <!-- PIED -->
          <div class="col-md-4 mb-3">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Joindre le pied de page
              </label>
              <Field name="pied" type="file" accept="image/jpeg, image/png, application/pdf"
                class="form-control shadow-none fs-md-15 text-black" placeholder="Pied de page" />
            </div>
            <ErrorMessage name="pied" class="text-danger" />
          </div>

          <div class="col-md-4 mb-3">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Lien API
              </label>
              <Field name="lienApi" type="text" class="form-control shadow-none fs-md-15 text-black"
                placeholder="Lien API" />
              <ErrorMessage name="lienApi" class="text-danger" />
            </div>
          </div>

          <div class="col-md-4 mb-3">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                API Nim
              </label>
              <Field name="apNim" type="text" class="form-control shadow-none fs-md-15 text-black"
                placeholder="API Nim" />
              <ErrorMessage name="apNim" class="text-danger" />
            </div>
          </div>

          <div class="col-md-8 mb-3">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                API Token
              </label>
              <Field name="apiToken" type="text" class="form-control shadow-none fs-md-15 text-black"
                placeholder="API Token" />
              <ErrorMessage name="apiToken" class="text-danger" />
            </div>
          </div>

          <div class="col-md-4 mb-3">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Format impression <span class="text-danger">*</span>
              </label>
              <Field name="formatImpression" v-model="formatImpression" v-slot="{ field }">
                <Multiselect :options="['A4', 'A5', 'A6', 'T1', 'T2']" :searchable="true" v-model="field.value"
                  v-bind="field" placeholder="Format impression" />
              </Field>
              <ErrorMessage name="formatImpression" class="text-danger" />
            </div>
          </div>

          <div class="col-md-12 mt-3">
            <div class="d-flex align-items-center ">
              <button class="btn btn-success me-3" type="submit" :disabled="!validPhone">
                Ajouter une société
              </button>
              <router-link to="/societes/liste-societes"
                class=" btn btn-danger"><i class="fa fa-trash-o lh-1 me-1 position-relative top-2"></i>
                <span class="position-relative"></span>Annuler</router-link>
            </div>
          </div>
        </div>
      </Form>
    </div>
  </div>
</template>

<script lang="ts">

import { defineComponent, ref } from 'vue';
import { Form, Field, ErrorMessage } from 'vee-validate';
import { error, success } from '@/utils/utils';
import { useRouter } from 'vue-router';
import ApiService from '@/services/ApiService';
import * as Yup from 'yup';
import Multiselect from "@vueform/multiselect";
import 'vue3-tel-input/dist/vue3-tel-input.css'
import { VueTelInput } from 'vue3-tel-input'

export default defineComponent({
  name: "AddSociete",
  components: {
    Form,
    Field,
    ErrorMessage,
    Multiselect,
    VueTelInput
  },
  setup: () => {
    // Le backend (entité Societe) exige : denomination, sigle, raisonSocial, ifu, rccm
    const societeSchema = Yup.object().shape({
      denomination: Yup.string().required('La dénomination est obligatoire'),
      sigle: Yup.string().required('Le sigle est obligatoire'),
      adresse: Yup.string().required('L\' adresse est obligatoire'),
      raisonSocial: Yup.string().required('La raison sociale est obligatoire'),
      rccm: Yup.string().required('Le N° RCCM est obligatoire'),
      ifu: Yup.string()
        .matches(/^\d{13}$/, 'La saisie doit avoir exactement 13 chiffres')
        .required('L\'ifu est obligatoire'),
      messageCommercial: Yup.string().notRequired(),
      lieuImpression: Yup.string().notRequired(),
      logo: Yup.mixed().notRequired(),
      entete: Yup.mixed().notRequired(),
      pied: Yup.mixed().notRequired(),
      apNim: Yup.string().notRequired(),
      apiToken: Yup.string().notRequired(),
      lienApi: Yup.string().notRequired(),
      telephone: Yup.number().typeError('Veuillez entrer des chiffres').required('Le téléphone est obligatoire'),
      formatImpression: Yup.string().required("Le format d'impression est obligatoire"),
      estModeMecef: Yup.boolean().notRequired().default(false),
      estRegimeTPS: Yup.boolean().notRequired().default(false),
    });

    // Valeurs par défaut du formulaire d'ajout
    const initialValues = {
      estRegimeTPS: false,
      estModeMecef: false,
      formatImpression: 'A4',
    };

    const router = useRouter();

    const telephone = ref();
    const validPhone = ref<boolean>(false);
    const formatImpression = ref('A4');

    function validate(phoneObject) {
      validPhone.value = phoneObject.valid;
      if (phoneObject.valid == true) {
        telephone.value = phoneObject.number;
      } else {
        telephone.value = "";
      }
    }

    const addSociete = async (values: any, { resetForm }) => {
      // On n'envoie pas les fichiers vides (logo, entête, pied de page non renseignés)
      ['logo', 'entete', 'pied'].forEach((champ) => {
        const val = values[champ];
        const estVide =
          val === undefined ||
          val === null ||
          val === '' ||
          (val instanceof FileList && val.length === 0) ||
          (typeof val === 'object' && !(val instanceof File) && !(val instanceof FileList) && Object.keys(val).length === 0);

        if (estVide) {
          delete values[champ];
        }
      });

      // postWithFile ajoute automatiquement le pointvente et envoie en multipart/form-data
      ApiService.postWithFile("/societes", values)
        .then(({ data }) => {
          // createSociete renvoie le code 201
          if (data.code == 201 || data.code == 200) {
            success(data.message);
            resetForm();
            router.push({ name: "ListeMaSociete" });
          }
        })
        .catch(({ response }) => {
          error(response.data.message);
        });
    };

    return {
      societeSchema,
      initialValues,
      addSociete,
      formatImpression,
      validPhone,
      telephone,
      validate,
    };
  },
});
</script>